import {
  stripeSubscriptionSuccess,
  stripeSubscriptionFail,
  stripeProductSuccess,
  stripeProductFail,
  stripeCustomerSuccess,
  stripeCustomerFail,
  stripeCustomerPaymentMethodSuccess,
  stripeCustomerPaymentMethodFail,
  stripeCustomerTransactionSuccess,
  stripeCustomerTransactionFail,
  stripeCustomerPaymentMethodsSuccess,
  stripeCustomerPaymentMethodsFail,
  stripeCustomerAllPaidInvoicesSuccess,
  stripeCustomerAllPaidInvoicesFail,
  stripeProductsSuccess,
  stripeProductsFail,
  stripePriceSuccess,
  stripePriceFail,
  stripeSubscriptionUpdateSuccess,
  stripeSubscriptionUpdateFail,
} from "../constant";
import { toast } from "react-toastify";

export const initialState = {
  subscriptionByIdSuccess: null,
  subscriptionByIdFail: null,
  productByIdSuccess: null,
  productByIdFail: null,
  customerByIdSuccess: null,
  customerByIdFail: null,
  customerPaymentMethodByIdSuccess: null,
  customerPaymentMethodByIdFail: null,
  customerTransactionsByIdSuccess: null,
  customerTransactionsByIdFail: null,
  customerPaymentMethodsByIdSuccess: null,
  customerPaymentMethodsByIdFail: null,
  customerAllPaidInvoicesByIdSuccess: null,
  customerAllPaidInvoicesByIdFail: null,
  allProductsSuccess: null,
  allProductsFail: null,
  priceByIdSuccess: null,
  priceByIdFail: null,
  subscriptionUpdateSuccess: null,
  subscriptionUpdateFail: null,
};

let toastConfig = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 2500,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case stripeSubscriptionSuccess:
      return {
        ...state,
        subscriptionByIdSuccess: action.payload,
      };
    case stripeSubscriptionFail:
      return {
        ...state,
        subscriptionByIdFail: action.payload.message,
      };
    case stripeProductSuccess:
      return {
        ...state,
        productByIdSuccess: action.payload,
      };
    case stripeProductFail:
      return {
        ...state,
        productByIdFail: action.payload.message,
      };
    case stripeCustomerSuccess:
      return {
        ...state,
        customerByIdSuccess: action.payload,
      };
    case stripeCustomerFail:
      return {
        ...state,
        customerByIdFail: action.payload.message,
      };
    case stripeCustomerPaymentMethodSuccess:
      return {
        ...state,
        customerPaymentMethodByIdSuccess: action.payload,
      };
    case stripeCustomerPaymentMethodFail:
      return {
        ...state,
        customerPaymentMethodByIdFail: action.payload.message,
      };
    case stripeCustomerTransactionSuccess:
      return {
        ...state,
        customerTransactionsByIdSuccess: action.payload,
      };
    case stripeCustomerTransactionFail:
      return {
        ...state,
        customerTransactionsByIdFail: action.payload.message,
      };
    case stripeCustomerPaymentMethodsSuccess:
      return {
        ...state,
        customerPaymentMethodsByIdSuccess: action.payload,
      };
    case stripeCustomerPaymentMethodsFail:
      return {
        ...state,
        customerPaymentMethodsByIdFail: action.payload.message,
      };
    case stripeCustomerAllPaidInvoicesSuccess:
      return {
        ...state,
        customerAllPaidInvoicesByIdSuccess: action.payload,
      };
    case stripeCustomerAllPaidInvoicesFail:
      return {
        ...state,
        customerAllPaidInvoicesByIdFail: action.payload.message,
      };
    case stripeProductsSuccess:
      return {
        ...state,
        allProductsSuccess: action.payload,
      };
    case stripeProductsFail:
      return {
        ...state,
        allProductsFail: action.payload.message,
      };
    case stripePriceSuccess:
      return {
        ...state,
        priceByIdSuccess: action.payload,
      };
    case stripePriceFail:
      return {
        ...state,
        priceByIdFail: action.payload.message,
      };
    case stripeSubscriptionUpdateSuccess:
      return {
        ...state,
        subscriptionUpdateSuccess: action.payload,
      };
    case stripeSubscriptionUpdateFail:
      return {
        ...state,
        subscriptionUpdateFail: action.payload.message,
      };
    default:
      return state;
  }
}
